/* RESPONSIBLE TEAM: team-reporting */
import { helper as buildHelper } from '@ember/component/helper';

export default buildHelper(function ([key, value]) {
  return {
    [key]: value,
  };
});
